import React, { useContext, useEffect } from "react";

import { FetchContext, NavContext, NavRoutes } from "../../contexts";
import { HomeContext, HomeProvider } from "./HomeContext";

import { Box, Card, CardActionArea, Grid, LinearProgress, Typography, } from "@mui/material";
import { Container } from "@mui/system";

import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal, } from "@azure/msal-react";
import { loginRequest } from "../../../authConfig.js";
import { ValoreRuoli } from "../../../helpers/Common";

const PageContent = (props) => {
    const { user } = useContext(FetchContext);

    const {
        addBreadcrumbToken,
        clearBreadcrumbs,
        setBreadcrumbRoot,
        switchTo,
        navigateTo,
    } = useContext(NavContext);

    const {
        comuniWithoutOffice,
        ufficiUncovalidated,
        isLoadingComuni,
        getComuniAsync,
        isLoadingUffici,
        getUfficiAsync,
    } = useContext(HomeContext);

    const { instance, accounts } = useMsal();

    const handleLogin = () => {
        instance.loginRequest = loginRequest;
        instance.loginRedirect();
    };

    const boxSX = {
        color: "whitesmoke",
        backgroundColor: "secondary.main",

        "&:hover": {
            backgroundColor: "secondary.light",

            //backgroundColor: 'lightblue'
        },
    };

    useEffect(() => {
        if (user) {
            getComuniAsync();
            getUfficiAsync();
        }
    }, [user]);

    useEffect(() => {
        setBreadcrumbRoot("Area riservata");
    }, []);

    return (
        <>
            <AuthenticatedTemplate>
                <Container>
                    <Typography
                        sx={{ color: "secondary.main" }}
                        fontSize={24}
                        fontWeight={600}
                    >
                        Modifica dati
                    </Typography>
                </Container>
                <br />
                {!user && (
                    <Container>
                        <Typography>Non sei autorizzato all'area riservata.</Typography>
                        <Typography>
                            La preghiamo di contattare l'amministratore del portale per
                            richiedere l'accesso.
                        </Typography>
                    </Container>
                )}
                <Container>
                    {(isLoadingComuni || isLoadingUffici) && <LinearProgress />}
                    {(user?.ruolo?.valoreRuolo == ValoreRuoli.Amministratore ||
                        user?.ruolo?.valoreRuolo == ValoreRuoli.Gestore) &&
                        comuniWithoutOffice && (
                            <Card sx={{ backgroundColor: "#fff9c4", padding: "8px" }}>
                                <CardActionArea onClick={() => navigateTo(`${NavRoutes.Comuni}?orphans=true`)}>
                                    {/* <WarningIcon sx={{margin:'auto'}}/> */}
                                    <Typography sx={{ fontWeight: "bold" }}>
                                        ATTENZIONE!
                                    </Typography>{" "}
                                    <Typography sx={{}}>
                                        Ci sono comuni che non hanno un ufficio assegnato per ogni
                                        competenza.
                                    </Typography>
                                </CardActionArea>
                            </Card>
                        )}
                    {ufficiUncovalidated && (
                        <Card
                            sx={{ backgroundColor: "#fff9c4", padding: "8px", marginTop: 2 }}
                        >
                            <CardActionArea onClick={() => navigateTo(`${NavRoutes.Uffici}?notConvalidated=true`)}>
                                {/* <WarningIcon sx={{margin:'auto'}}/> */}
                                <Typography sx={{ fontWeight: "bold" }}>
                                    ATTENZIONE!
                                </Typography>{" "}
                                <Typography sx={{}}>Ci sono uffici non convalidati.</Typography>
                            </CardActionArea>
                        </Card>
                    )}
                </Container>
                <br />

                <Box sx={{ backgroundColor: "aliceblue" }}>
                    <Container>
                        <Grid container>
                            {user?.ruolo?.valoreRuolo == ValoreRuoli.Amministratore && (
                                <Grid item xs={3}>
                                    <Card
                                        sx={{
                                            backgroundColor: "secondary.main",
                                            margin: "8px",
                                            paddingY: "32px",
                                            paddingX: "16px",
                                        }}
                                    >
                                        <CardActionArea
                                            onClick={() => switchTo(NavRoutes.Competenze)}
                                        >
                                            <Typography align="center" sx={{ color: "white" }}>
                                                Competenze
                                            </Typography>
                                        </CardActionArea>
                                    </Card>
                                </Grid>
                            )}
                            {(user?.ruolo?.valoreRuolo == ValoreRuoli.Amministratore ||
                                user?.ruolo?.valoreRuolo == ValoreRuoli.Gestore) && (
                                    <Grid item xs={3}>
                                        <Card
                                            sx={{
                                                backgroundColor: "secondary.main",
                                                margin: "8px",
                                                paddingY: "32px",
                                                paddingX: "16px",
                                            }}
                                        >
                                            <CardActionArea onClick={() => switchTo(NavRoutes.Comuni)}>
                                                <Typography align="center" sx={{ color: "white" }}>
                                                    Comuni
                                                </Typography>
                                            </CardActionArea>
                                        </Card>
                                    </Grid>
                                )}
                            {(user?.ruolo?.valoreRuolo == ValoreRuoli.Amministratore ||
                                user?.ruolo?.valoreRuolo == ValoreRuoli.Gestore) && (
                                    <Grid item xs={3}>
                                        <Card
                                            sx={{
                                                backgroundColor: "secondary.main",
                                                margin: "8px",
                                                paddingY: "32px",
                                                paddingX: "16px",
                                            }}
                                        >
                                            <CardActionArea
                                                onClick={() => switchTo(NavRoutes.TipiUffici)}
                                            >
                                                <Typography align="center" sx={{ color: "white" }}>
                                                    Ambiti/Tipi Ufficio
                                                </Typography>
                                            </CardActionArea>
                                        </Card>
                                    </Grid>
                                )}
                            {(user?.ruolo?.valoreRuolo == ValoreRuoli.Amministratore ||
                                user?.ruolo?.valoreRuolo == ValoreRuoli.Gestore ||
                                user?.ruolo?.valoreRuolo == ValoreRuoli.Redattore) && (
                                    <Grid item xs={3}>
                                        <Card
                                            sx={{
                                                backgroundColor: "secondary.main",
                                                margin: "8px",
                                                paddingY: "32px",
                                                paddingX: "16px",
                                            }}
                                        >
                                            <CardActionArea
                                                onClick={() => switchTo(NavRoutes.TipiContatti)}
                                            >
                                                <Typography align="center" sx={{ color: "white" }}>
                                                    Tipi attributo
                                                </Typography>
                                            </CardActionArea>
                                        </Card>
                                    </Grid>
                                )}
                            {(user?.ruolo?.valoreRuolo == ValoreRuoli.Amministratore ||
                                user?.ruolo?.valoreRuolo == ValoreRuoli.Gestore ||
                                user?.ruolo?.valoreRuolo == ValoreRuoli.Redattore) && (
                                    <Grid item xs={3}>
                                        <Card
                                            sx={{
                                                backgroundColor: "secondary.main",
                                                margin: "8px",
                                                paddingY: "32px",
                                                paddingX: "16px",
                                            }}
                                        >
                                            <CardActionArea onClick={() => switchTo(NavRoutes.Uffici)}>
                                                <Typography align="center" sx={{ color: "white" }}>
                                                    Uffici
                                                </Typography>
                                            </CardActionArea>
                                        </Card>
                                    </Grid>
                                )}
                            {user?.ruolo?.valoreRuolo == ValoreRuoli.Amministratore && (
                                <Grid item xs={3}>
                                    <Card
                                        sx={{
                                            backgroundColor: "secondary.main",
                                            margin: "8px",
                                            paddingY: "32px",
                                            paddingX: "16px",
                                        }}
                                    >
                                        <CardActionArea onClick={() => switchTo(NavRoutes.Regioni)}>
                                            <Typography align="center" sx={{ color: "white" }}>
                                                Regioni
                                            </Typography>
                                        </CardActionArea>
                                    </Card>
                                </Grid>
                            )}
                            {user?.ruolo?.valoreRuolo == ValoreRuoli.Amministratore && (
                                <Grid item xs={3}>
                                    <Card
                                        sx={{
                                            backgroundColor: "secondary.main",
                                            margin: "8px",
                                            paddingY: "32px",
                                            paddingX: "16px",
                                        }}
                                    >
                                        <CardActionArea
                                            onClick={() => switchTo(NavRoutes.Province)}
                                        >
                                            <Typography align="center" sx={{ color: "white" }}>
                                                Province
                                            </Typography>
                                        </CardActionArea>
                                    </Card>
                                </Grid>
                            )}
                            {user?.ruolo?.valoreRuolo == ValoreRuoli.Amministratore && (
                                <Grid item xs={3}>
                                    <Card
                                        sx={{
                                            backgroundColor: "secondary.main",
                                            margin: "8px",
                                            paddingY: "32px",
                                            paddingX: "16px",
                                        }}
                                    >
                                        <CardActionArea onClick={() => switchTo(NavRoutes.Utenti)}>
                                            <Typography align="center" sx={{ color: "white" }}>
                                                Utenti
                                            </Typography>
                                        </CardActionArea>
                                    </Card>
                                </Grid>
                            )}
                            {user?.ruolo?.valoreRuolo == ValoreRuoli.Amministratore && (
                                <Grid item xs={3}>
                                    <Card
                                        sx={{
                                            backgroundColor: "secondary.main",
                                            margin: "8px",
                                            paddingY: "32px",
                                            paddingX: "16px",
                                        }}
                                    >
                                        <CardActionArea
                                            onClick={() => switchTo(NavRoutes.Impostazione)}
                                        >
                                            <Typography align="center" sx={{ color: "white" }}>
                                                Impostazioni
                                            </Typography>
                                        </CardActionArea>
                                    </Card>
                                </Grid>
                            )}
                        </Grid>
                    </Container>
                </Box>
            </AuthenticatedTemplate>

            <UnauthenticatedTemplate>
                <Container>
                    <center>
                        <Typography>
                            Benvenuto nel portale di gestione di Giustizia Map del Ministero della Giustizia
                        </Typography>
                    </center>
                    <UnauthenticatedTemplate>
                        <center>
                            <Typography>
                                Per proseguire effettua l'accesso con ADN, SPID, CIE o CNS
                            </Typography>
                        </center>
                    </UnauthenticatedTemplate>
                </Container>
            </UnauthenticatedTemplate>
        </>
    );
};

export const HomePage = () => {
    return (
        <HomeProvider>
            <PageContent />
        </HomeProvider>
    );
};
